import React from 'react';
import { getCommonStyles } from '../styles/commonStyles';

interface ActionButtonsProps {
  isDarkTheme?: boolean;
  onCancel: () => void;
  onSave: () => void;
  onSubmit: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isDarkTheme,
  onCancel,
  onSave,
  onSubmit
}) => {
  const commonStyles = getCommonStyles(isDarkTheme || false);

  return (
    <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
      <button
        style={commonStyles.button}
        onClick={onCancel}
      >
        Cancel
      </button>
      <button
        style={commonStyles.button}
        onClick={onSave}
      >
        Save
      </button>
      <button
        style={commonStyles.button}
        onClick={onSubmit}
      >
        Submit
      </button>
    </div>
  );
};

export default ActionButtons;